import { BaseResourceModel } from '@sicapes/core';
import {ParametroAreasTematica} from '../parametrizacao/parametro-projeto-area-tematica.model';

export class InscricaoAreaTematicaModel extends BaseResourceModel {
    constructor(
        public id?: number,
        public parametro_area_tematica?: ParametroAreasTematica,
) {
        super();
    }

    static fromJson(jsonData: any): InscricaoAreaTematicaModel {
        return Object.assign(new InscricaoAreaTematicaModel(), jsonData);
    }
}
